// extracted by mini-css-extract-plugin
module.exports = {"EstimateTitle":"Page_EstimateTitle__9w6nE","Container":"Page_Container__blWxJ","EstimateAddForm":"Page_EstimateAddForm__ndOCY","EstimateList":"Page_EstimateList__Arxf1"};